import React, { createRef, useEffect } from "react";
import TableHeader from "./TableHeader";
import { TableColumn } from "../../models/table";
import styles from "./Table.module.scss";

interface Props {
  columns?: TableColumn[];
  children?: string | JSX.Element | JSX.Element[];
  className?: string;
}

const Table = ({ columns, children, className = "" }: Props) => {
  const tableBody = createRef<HTMLDivElement>();

  // Apply column width on each table row cell
  useEffect(() => {
    if (!tableBody || !tableBody.current || !columns) {
      return;
    }

    const tableRows = tableBody.current.querySelectorAll(`.${styles.tableRow}`);
    const gridTemplateColumns = columns.map((column) => column.width || "1fr").join(" ");

    tableRows.forEach((tableRow) => ((tableRow as HTMLDivElement).style.gridTemplateColumns = gridTemplateColumns));
  }, [tableBody, columns]);

  return (
    <div className={`${styles.table} ${className}`.trim()}>
      {columns && <TableHeader columns={columns} />}
      <div className={styles.tableBody} ref={tableBody}>
        {children}
      </div>
    </div>
  );
};

export default Table;
